import { WidgetRegistryEntry, WidgetTemplateComponentFactory } from "@smallstack/widget-core";
import { CustomerCompoundWidgetDefinition } from "@smallstack/widget-shared";

export const UserListWidget: WidgetRegistryEntry = {
  name: "UserList",
  configuration: () => import("./configuration").then((m) => m.UserListWidgetConfiguration),
  component: async () => WidgetTemplateComponentFactory.withTemplate(CustomerCompoundWidgetDefinition)
};
